import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import EventCard from "@/components/EventCard";
import { AREAS } from "@/lib/constants";
import { Search } from "lucide-react";

export default function Eventi() {
  const [params, setParams] = useSearchParams();
  const [events, setEvents] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const [area, setArea] = useState(params.get("area") || "");
  const [upcoming, setUpcoming] = useState(true);

  useEffect(() => {
    const p = new URLSearchParams();
    if (area) p.set("area", area);
    if (q) p.set("q", q);
    if (upcoming) p.set("upcoming_only", "true");
    api.get(`/events?${p.toString()}`).then((r) => setEvents(r.data));
    setParams(p);
  }, [q, area, upcoming]);

  return (
    <div data-testid="eventi-page">
      <section className="bg-[#FFF1E8] py-16 lg:py-20">
        <div className="container-vv">
          <div className="eyebrow">Eventi</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl tracking-tight text-[#292522]">Vieni a un incontro</h1>
          <p className="mt-4 text-lg text-[#292522]/75 max-w-3xl">Trova l'evento giusto per te: laboratori, camminate, gruppi di parola, feste di comunità. La partecipazione è quasi sempre gratuita.</p>
        </div>
      </section>

      <section className="container-vv py-8 lg:py-10 sticky top-20 z-30 bg-[#FFFCF8]/90 backdrop-blur-md">
        <div className="flex flex-wrap gap-3 items-center">
          <label className="relative flex-1 min-w-[220px]">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#292522]/40" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Cerca un evento…"
              className="w-full pl-11 pr-4 py-3 rounded-full bg-white border border-[#292522]/10 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm"
              data-testid="events-search-input"
            />
          </label>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => setArea("")} className={`px-4 py-2 rounded-full text-xs font-semibold border ${!area ? "bg-[#FF6100] text-white border-[#FF6100]" : "bg-white text-[#292522] border-[#292522]/10 hover:border-[#FF6100]"}`}>Tutte</button>
            {AREAS.map((a) => (
              <button key={a.key} onClick={() => setArea(a.key)} data-testid={`event-filter-${a.key}`} className={`px-4 py-2 rounded-full text-xs font-semibold border ${area === a.key ? "bg-[#FF6100] text-white border-[#FF6100]" : "bg-white text-[#292522] border-[#292522]/10 hover:border-[#FF6100]"}`}>{a.short}</button>
            ))}
          </div>
          <label className="inline-flex items-center gap-2 text-xs font-semibold text-[#292522]/75">
            <input type="checkbox" checked={upcoming} onChange={(e) => setUpcoming(e.target.checked)} className="accent-[#FF6100]" />
            Solo prossimi
          </label>
        </div>
      </section>

      <section className="container-vv pb-24">
        {events.length === 0 ? (
          <div className="rounded-3xl bg-[#FFF1E8] p-12 text-center text-[#292522]/70">Nessun evento trovato con questi filtri.</div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {events.map((ev, i) => <EventCard key={ev.id} event={ev} testId={`event-card-${i}`} />)}
          </div>
        )}
      </section>
    </div>
  );
}
